"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ArrowDropDown = _interopRequireDefault(require("@material-ui/icons/ArrowDropDown"));

var _Popover = _interopRequireDefault(require("@material-ui/core/Popover"));

var _Contacts = require("../Contacts");

var EmailSelect = function EmailSelect(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      options = _ref.options,
      className = _ref.className,
      disabled = _ref.disabled,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["value", "onChange", "options", "className", "disabled"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var rootRef = (0, _react.useRef)();
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, rest, {
    ref: rootRef,
    className: (0, _classnames["default"])('text-sm inline-flex select-none items-center px-2 py-1 cursor-pointer hover:bg-secondary rounded', {
      'bg-gray-divider': open
    }, className),
    onClick: function onClick() {
      return !disabled && setOpen(true);
    }
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "truncate",
    style: {
      maxWidth: 300
    }
  }, value), /*#__PURE__*/_react["default"].createElement(_ArrowDropDown["default"], {
    className: "text-gray-medium"
  })), /*#__PURE__*/_react["default"].createElement(_Popover["default"], {
    open: open,
    anchorEl: rootRef.current,
    onClose: function onClose() {
      return setOpen(false);
    },
    elevation: 4,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    }
  }, options.map(function (each, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: each.email,
      className: (0, _classnames["default"])("outline-none flex items-center px-4 py-1 hover:bg-secondary", {
        'bg-secondary': value === each.email
      }),
      style: {
        maxWidth: 400,
        minHeight: '60px'
      },
      onClick: function onClick() {
        setOpen(false);
        each.email !== value && onChange(each.email);
      }
    }, /*#__PURE__*/_react["default"].createElement(_Contacts.Contact, each));
  })));
};

var _default = EmailSelect;
exports["default"] = _default;
//# sourceMappingURL=index.js.map